import { render } from "./LanguageSelect.vue?vue&type=template&id=6941144b"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/LanguageSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6941144b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6941144b', __exports__)) {
    api.reload('6941144b', __exports__)
  }
  
  module.hot.accept("./LanguageSelect.vue?vue&type=template&id=6941144b", () => {
    api.rerender('6941144b', render)
  })

}


export default __exports__